
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class backofficeCustom extends Vue {

    @Prop() item: OM.BackofficeCustom;

    onClick(){
        if(this.item.navigationPath){
            this.$router.push(this.item.navigationPath)
            .then(x => {
                this.$emit('clicked');
            });
        } else {
            this.$emit('clicked');
        }
    }

}
